'use strict';

var React = require('react');
require('prop-types');
var Typography = require('../../DataDisplay/Typography/Typography.js');
var Button = require('../../Inputs/Buttons/Button/Button.js');
var Grid = require('../../Layout/Grid/Grid.js');
var withStyles = require('../../Styles/withStyles.js');
var Paper = require('../../Surfaces/Paper/Paper.js');
var withWidth = require('../../../node_modules/@material-ui/core/esm/withWidth/withWidth.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    button: {
      margin: 'auto'
    },
    white: {
      backgroundColor: theme.palette.background.white,
      border: "1px solid ".concat(theme.palette.divider),
      padding: '16px 12px 16px 12px',
      borderRadius: '10px'
    },
    yellow: {
      backgroundColor: theme.palette.alert.light,
      border: "1px solid ".concat(theme.palette.alert.main),
      padding: '16px 12px 16px 12px',
      borderRadius: '10px'
    }
  };
};

var SparkySays = function SparkySays(_ref) {
  var classes = _ref.classes,
      color = _ref.color,
      width = _ref.width,
      subtitle = _ref.subtitle,
      caption = _ref.caption,
      CTA = _ref.CTA,
      onClick = _ref.onClick;
  var isSmallScreen = width === 'xs';
  return React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement(Paper, {
    elevation: 0,
    className: classes[color],
    rounded: 1
  }, React__default["default"].createElement(Grid, {
    container: true,
    justify: 'space-between',
    alignItems: 'center',
    spacing: 16
  }, React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(Typography, {
    variant: "subtitle1",
    gutterBottom: true
  }, subtitle), React__default["default"].createElement(Typography, {
    variant: "body1",
    color: "textSecondary"
  }, caption)), React__default["default"].createElement(Grid, {
    item: true,
    className: isSmallScreen ? classes.button : ''
  }, React__default["default"].createElement(Button["default"], {
    variant: "contained",
    color: "primary",
    onClick: onClick
  }, CTA)))));
};

var SparkySays$1 = withWidth["default"]()(withStyles["default"](styles)(SparkySays));

module.exports = SparkySays$1;
